module.exports = __webpack_public_path__ + "static/assets/10048f926e8aba633013662161115250.svg";